import React from 'react'
import './footer.css'


const quickLinks01 = [
    {
        path: '#contact',
        display: 'Email'
    },
    {
        path: '#',
        display: 'Phone Number'
    },
    {
        path: '#',
        display: 'Gmail'
    },
]
const quickLinks02 = [
    {
        path: '#projects',
        display: 'First'
    },
    {
        path: '#projects',
        display: 'Second'
    },
    {
        path: '#projects',
        display: 'Tertiary'
    },
]
const quickLinks03 = [
    {
        path: '#about',
        display: 'About'
    },
    {
        path: '#blog',
        display: 'Product'
    },
    {
        path: '#service',
        display: 'Needs'
    },
]


export default function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="footer">
        <div className="container" style={{height: '100%'}}>
            <div className="footer_wrapper">
                <div className="footer_logo">
                    <h2>SmartSen</h2>
                    <p className="description">Grow with us</p>
                    <p className="small_text description">
                        be part of the future
                    </p>
                </div>
                <div className="footer_quick-links">
                    <h3 className="quick_links-title">Contact Us</h3>
                    <ul className="quick_links">
                        {
                            quickLinks01.map((item, index) => (
                                <li className="quick_link-item" key={index}><a href={item.path}>{item.display}</a></li>
                            ))
                        }
                    </ul>
                </div>
                <div className="footer_quick-links">
                    <h3 className="quick_links-title">Selution</h3>
                    <ul className="quick_links">
                        {
                            quickLinks02.map((item, index) => (
                                <li className="quick_link-item" key={index}><a href={item.path}>{item.display}</a></li>
                            ))
                        }
                    </ul>
                </div>
                <div className="footer_quick-links">
                    <h3 className="quick_links-title">Company</h3>
                    <ul className="quick_links">
                        {
                            quickLinks03.map((item, index) => (
                                <li className="quick_link-item" key={index}><a href={item.path}>{item.display}</a></li>
                            ))
                        }
                    </ul>
                </div>
            </div>
            <p className="copyright"> {year} © All Rights Reserved - SmartSen</p>
        </div>
    </footer>
  )
}
